import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import { useDocumentData, useDocumentViewerApi, useLocalization } from "../../hooks/index.js";
import { ConfirmationDialog } from "../confirmation-dialog.js"; // type DeleteButtonProps = Pick<CommentPropType, 'deleteComment' | 'id'>

/**
 * Represents a delete button with confirmation dialog
 */
export const DeleteButton = props => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const api = useDocumentViewerApi();
  const {
    documentData
  } = useDocumentData();
  const localization = useLocalization();

  const handleClick = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = isCanceled => {
    if (!isCanceled) {
      api.commentActions.deletePreviewComment({
        document: documentData,
        commentId: props.comment.id,
        abortController: new AbortController()
      });
    }

    setIsDialogOpen(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    size: "small",
    onClick: handleClick
  }, localization.delete), /*#__PURE__*/React.createElement(ConfirmationDialog, {
    dialogTitle: localization.deleteCommentDialogTitle,
    cancelButtonText: localization.cancelButton,
    okButtonText: localization.okButton,
    isOpen: isDialogOpen,
    onClose: handleDialogClose
  }, localization.deleteCommentDialogBody));
};
//# sourceMappingURL=delete-comment-button.js.map